<!-- Text column -->
<div class="order-2 lg:order-none" data-aos="fade-up">
  <!-- Kicker -->
  <span
    class="block text-[10px] font-bold uppercase tracking-[2px] mb-5"
    style="color: #838a98"
  >
    {{ "talentSearchV2.exactHire.kicker" | translate }}
  </span>

  <!-- Heading -->
  <h2
    class="text-3xl md:text-5xl lg:text-[54px] font-black leading-[1.1] tracking-[-2px] text-[#061430] mb-6"
    [innerHTML]="'talentSearchV2.exactHire.title' | translate | accent">
  </h2>

  <!-- Subtitle -->
  <p class="text-base text-[#3B4A6B] leading-[1.75] max-w-[380px] mb-6">
    {{ "talentSearchV2.exactHire.desc" | translate }}
  </p>

  <!-- Pills -->
  <div class="flex flex-wrap gap-2 mb-8">
    <span
      class="bg-[#061430] text-white text-xs font-semibold rounded-full py-[7px] px-4"
    >
      {{ "talentSearchV2.exactHire.pill1" | translate }}
    </span>
    <span
      class="bg-[#061430] text-white text-xs font-semibold rounded-full py-2 px-4"
    >
      {{ "talentSearchV2.exactHire.pill2" | translate }}
    </span>
  </div>

  <!-- CTA -->
  <button
    type="button"
    (click)="openBookDemo()"
    class="inline-flex items-center gap-2 text-sm font-semibold rounded-full bg-primary shadow-[0px_4px_16px_0px_#353CD84D] text-white py-4 px-8 transition-all hover:brightness-105"
  >
    {{ "talentSearchV2.exactHire.cta" | translate }}
    <span class="inline-grid place-items-center rtl:flip"><app-icon name="tabler:arrow-narrow-right" [size]="18" /></span>
  </button>
</div>

<!-- Image column -->
<div class="order-1 lg:order-none" data-aos="fade-up" data-aos-delay="100">
  <div class="rounded-[20px]">
    <app-responsive-img
      name="hire-1"
      [alt]="'talentSearchV2.exactHire.imageAlt' | translate"
      imgClass="w-full h-auto block select-none pointer-events-none rounded-xl"
      sizes="(min-width: 1024px) 50vw, 100vw"
    />
  </div>
</div>
